import { BuildStageMappedItem, BuildStagesLogicService, IBuildStageDto, IBuildStageMappedItem } from '@app/logic/build-stages';
import { Component } from '@angular/core';
import { BaseSimpleListViewDirective } from '@app/shared/base-views/base-simple-list-view.directive';
import { BuildStageDialogComponent } from './components/build-stage-dialog/build-stage-dialog.component';
import { CONSTRUCTION_MANAGER_ROLE_ENUM } from '@classictechsolutions/hubapi-transpiled-enums';
import { CbDialogService } from '@app/shared/components/dialog/cb-dialog.service';
import { CbEnumService } from '@app/core/services/enum/enum.service';
import { PermissionsPermissions } from '@app/core/permissions';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { take } from 'rxjs';

@Component({
    selector: 'cb-build-stages',
    templateUrl: './build-stages.component.html',
    styleUrls: ['./build-stages.component.scss'],
    providers: [BuildStagesLogicService],
    standalone: false
})
export class BuildStagesComponent extends BaseSimpleListViewDirective<IBuildStageDto, BuildStagesLogicService> {

    public searchResults: IBuildStageMappedItem[] = [];
    public constructionManagerRoles = CONSTRUCTION_MANAGER_ROLE_ENUM.toSelectList();
    public buildStagesLoaded = false;

    public sortOrderChanged = false;

    public readonly displayedColumns: string[] = ['code', 'label', 'manager', 'active', 'isPreconsentStage','actions'];

    constructor(
        public readonly enumService: CbEnumService,
        public readonly permissionsPermissions: PermissionsPermissions,
        public readonly dialog: CbDialogService,
        private readonly buildStagesLogicService: BuildStagesLogicService
    ) {
        super(
            dialog,
            buildStagesLogicService,
            BuildStageDialogComponent,
            'Build Stage',
            BuildStageMappedItem,
            permissionsPermissions
        );
    }

    public drop(event: CdkDragDrop<IBuildStageMappedItem[]>): void {
        if (event.previousIndex !== event.currentIndex) {
            moveItemInArray(this.searchResults, event.previousIndex, event.currentIndex);
            this.searchResults = [...this.searchResults];
            this.sortOrderChanged = true;
        }
    }

    protected handleSearchResults = (searchResults: Array<IBuildStageDto>) => {
        super.handleSearchResults(searchResults);
    };

    protected handleNewItem = (item: any) => {
        super.handleNewItem(item);
    };

    public getConstructionManagerRole(constructionManagerRole: number): string {
        let returnValue = '';
        if (constructionManagerRole) {
            returnValue = this.constructionManagerRoles.find(role => role.id === constructionManagerRole).label;
        }

        return returnValue;
    }

    public saveOrder(): void {
        this.dialog
            .confirm({
                message: 'Are you sure you want to save the order of the Build Stages?',
                confirmed: this.handleSaveOrder,
            });
    }

    private readonly handleSaveOrder = (): void => {
        this.buildStagesLogicService
            .saveOrder(this.searchResults)
            .pipe(take(1)).subscribe((result) => {
                this.searchResults = result;
                this.sortOrderChanged = false;
            });
    };
}
